import React from 'react'
import Nav from './Nav'

import './HeaderRes.scss'

const Header = () => {
  return <Nav/>
}

export default Header


// WEBPACK FOOTER //
// ./src/components/includes/Nav/Header.js